import React, { useState, useContext, useEffect } from 'react';
import axios from 'axios';
import { v4 as uuid } from 'uuid';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';

import { mapiHeaders } from '../mapi/utils';
import { logWarning } from '../utils/sentry';
import { useSettings } from '../mall_settings/SettingsProvider';

import getBlackbox from './getBlackbox';

export const SessionContext = React.createContext();
export const SessionProvider = ({ timeToLive, children }) => {
    const { orderingToken, mapiUrl } = useSettings();
    const location = useLocation();
    const { loyalty } = useSettings();
    const [session, setSession] = useState();

    const storeSession = (sessionToStore) => {
        setSession(sessionToStore);
        window.localStorage.setItem('session', JSON.stringify(sessionToStore));
    };

        const createSession = (sessionKey, affiliateCode) =>
        new Promise(resolve => {
            const config = {
                headers: mapiHeaders(orderingToken)
            };
            const sessionUrl = `${mapiUrl || ''}/capi/mall/session`;
            const data = {
                sessionKey,
                affiliateCode,
                host: window.location.hostname
            };
            axios
                .post(sessionUrl, data, config)
                .then(response => {
                    const sessionId = response.data.sessionId;
                    resolve({sessionId})
                })
                .catch(error => {
                    resolve({error})
                });
        });
        const getDefaultSession = async () => {
        const cartId = uuid();
        const created = Date.now();
        const { sessionId } = await createSession(cartId, loyalty.name);
        const appId = await getBlackbox();
        return { cartId, appId, created, mapiSession: sessionId, lastSessionUpdate: created };
    };
        const getInitializeSession = async () => {
        const localSession = JSON.parse(window.localStorage.getItem('session') || "{}");
        if (localSession.cartId) {
            return localSession;
        }
        return getDefaultSession();
    };
        const updateSession = async () => {
        
        const currentSession = session || await getInitializeSession();
        const currentTimestamp = Date.now();
        const timeDiff = currentTimestamp - currentSession.lastSessionUpdate;
        
        if (timeDiff < timeToLive) {
            
            storeSession({ ...currentSession, lastSessionUpdate: currentTimestamp });
        } else {
            if (timeDiff < 0) {
                
                logWarning(
                    `Session timestamp is in the future`,
                    { session_lifetime: timeToLive },
                    { session_time: currentSession.lastSessionUpdate, current_time: currentTimestamp }
                );
            }
            
            const newSession = await getDefaultSession();
            storeSession({ ...newSession, previousSession: currentSession.cartId });
        }
    };
        const expireSession = () => {
        setSession({ ...session, lastSessionUpdate: session.lastSessionUpdate - ( 2 * timeToLive ) });
    };
        useEffect(() => {
        const doUpdateSession = async () => {
            await updateSession();
        };
        doUpdateSession().catch(() => {});
    }, [location]);

    return <SessionContext.Provider value={{ ...session, expireSession }}>{children}</SessionContext.Provider>;
};

SessionProvider.defaultProps = {
    timeToLive: 1000 * 60 * 60 * 24, 
};

SessionProvider.propTypes = {
    timeToLive: PropTypes.number,
    children: PropTypes.node.isRequired
};

export const useSession = () => useContext(SessionContext);
